import React, { Fragment } from 'react';
import { Col, Container, Row } from 'reactstrap';
import { getFromLocalStorage } from '../../hooks/useLocalStorage';

const AccessDenied = ()=> {
  const ROLE = getFromLocalStorage("ROLE");
    const redirectToDashboard = () => {
      window.location.href = '/dashboard/default'; // Redirects to the dashboard page
    };
  return (
    <Fragment>
    <div
      style={{
        color: '#444',
        margin: 0,
        fontFamily: 'Arial, Helvetica, sans-serif',
        height: '100%',
        backgroundColor: '#fff',
      }}
    >
      <Container fluid style={{ minHeight: '100vh' }}>
        <Row className="justify-content-center align-items-center" style={{ height: '100vh' }}>
          <Col xs="12" md="8" className="text-center">
            <h1 style={{ margin: 0, fontSize: '150px', lineHeight: '150px', fontWeight: 'bold' }}>403</h1>
            <h2 style={{ marginTop: '20px', fontSize: '30px' }}>Access Denied</h2>
            <p>Sorry, {ROLE?.name} do not have permission to access this page.</p>

            <a href="/dashboard/default" style={{ textDecoration: 'underline' }} onClick={redirectToDashboard}>
              Back to home page
            </a>
          </Col>
        </Row>
      </Container>
    </div>
  </Fragment>
  );
}

export default AccessDenied;
